export default {
  whenOptions: [
    {
      id: 1,
      name: 'Cambio de estado',
      value: 'process-status-change',
      component: 'ProcessStatusChange'
    }
  ],
  doOptions: [
    {
      id: 1,
      name: 'Requerir documentación',
      value: 'document-required',
      component: 'ProcessDocumentationNeeded'
    },
    {
      id: 2,
      name: 'Sugerir documentación',
      value: 'document-suggested',
      component: 'ProcessDocumentationNeeded'
    }
  ]
}
